import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke011aRequest, Sgke011aResponse ,Sgke011aService,} from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';



@Injectable({
  providedIn: 'root',
})
export class UsedSgke011aService {
  /**
   * コンストラクタ
   * @param {Sgke011aService}service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke011aService
   */
  constructor(
    public service: Sgke011aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) {}
  /**
   * SGKE011A_未精算整理照会初期表示API　呼出し
   * @param {Sgke011aRequest} request
   * @returns
   */
  public doSgke011a(request: Sgke011aRequest): Observable<Sgke011aResponse> {
    return this.service.SGKE011APost(this.apiCommonService.setRequestCommon(<any>request),'response'
      )
      .pipe(
        map((response) => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE011A');
          return throwError(err.message);
        })
      );
  }
}
